import "../assets/scss/index.scss";

import "./modules/Menu.js";
import "./modules/Slider.js";
import "./modules/Events.js";
import "./modules/Accordion.js";
import "./modules/Map.js";
import "./modules/Swup.js";
import "./modules/BeforeAfter";

var toolbar = document.getElementById("pojo-a11y-toolbar");

if (toolbar) {
  toolbar.addEventListener("click", function (event) {
    event.stopPropagation();

    if (toolbar.classList.contains("pojo-a11y-toolbar-open")) {
      toolbar.classList.remove("pojo-a11y-toolbar-open");
    } else {
      toolbar.classList.add("pojo-a11y-toolbar-open");
    }
  });
}
